import { ReactElement } from 'react'
import LinkList from '../../common/link-list'
import { LinkItemProps } from '../../common/link-list'
import { getRegions, useRegionsState } from '../../../stores/national-data/regions'
import PanelSection from '../../layout/panel-section'
import PanelHeader from '../../navigation/navigation-panel/panel-header'
import CloneNode from '../../clone-inner'
import DisclaimerBanner from '../../common/disclaimer-banner'
import { textFromSelector } from '../../textFromSelector'
import { useReturnMapToDefaultView } from '../../../hooks/use-return-map-to-default-view'

export default function RegionsList(): ReactElement {
  useReturnMapToDefaultView()
  useRegionsState()
  const regions = getRegions()

  const getRegionList: LinkItemProps[] = regions.map((region) => {
    return {
      title: region.properties.name,
      url: `/regions/${region.properties.slug}`,
    }
  })

  const onClick = () => {
    window.scrollTo(0, 0)
  }

  return (
    <>
      <PanelHeader
        filter
        title={textFromSelector('#page-title__region', 'Regions')}
        closeAriaLabel='Close regions info modal'
        // NZTAJP-699: customisable "how to use" copy, then the disclaimer below it
        // (SiteConfig.DisclaimerText, same hidden div the banner reads), so the
        // disclaimer doesn't have to be entered into the CMS twice.
        modalContent={
          <>
            <CloneNode selector='#modal-help__region' />
            <CloneNode selector='#page-help__journey-planner-disclaimer' className='c-modal__disclaimer' as='h5' />
          </>
        }
      />
      {/* NZTAJP-702: pinned above the region list (matching Highway conditions), rather
          than after it, so it doesn't fall below the list in mobile's in-panel flow. */}
      <DisclaimerBanner />
      <PanelSection hasVerticalPadding={false} navigation={true}>
        <LinkList links={getRegionList} onClick={onClick} />
      </PanelSection>
    </>
  )
}
